import { render, staticRenderFns } from "./NewCustomerDialog.vue?vue&type=template&id=8730cf8c&scoped=true&"
import script from "./NewCustomerDialog.vue?vue&type=script&lang=js&"
export * from "./NewCustomerDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerDialog.vue?vue&type=style&index=0&id=8730cf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8730cf8c",
  null
  
)

export default component.exports